__webpack_require__.p = "https://www.jg-cdn.com/assets/jg-pages-edge/_next/";